
  module.exports =
  {
    search: require('./COINSDevelopment/search'),
    developments: require('./COINSDevelopment/developments'),
  }